














































import { Component, Prop, Vue } from 'vue-property-decorator';
import SearchService from '@/services/SearchService';
import { Listing } from '@/models/Listing';
import L from 'leaflet';

@Component
export default class SearchManager extends Vue {

    public selectedValue: string = '';

    // expecting array {label: 'string', value: 'string', type: 'string', magicKey: optional}
    public listingAddressResults: any = [];
    public addressResults: any = [];
    public listingResults: any = [];
    public pidResults: any = [];

    public unsubscribe = this.$store.subscribeAction((action, state) => {
        // if (action.type === 'initSearch') {
        //     this.initSearch();
        // }
    });

    get map(): L.Map {
        return this.$store.state.map;
    }

    get config() {
        return this.$store.state.config;
    }

    get resultOptions() {
        return this.listingAddressResults.concat(this.addressResults).concat(this.listingResults).concat(this.pidResults);
    }

    public selectedResult(inputValue: any) {
        console.log('SearchManager: selectedResult()');
        console.log(inputValue); // same as this.selectedValue model

        const selectedListingMarkerPane = this.map.getPane('selectedListing');
        if (selectedListingMarkerPane) {
            selectedListingMarkerPane.style.display = 'block';
        }

        if (inputValue && inputValue.type && inputValue.type === 'address') {
            // address result selected
            SearchService.esriGeocoderCandidates(inputValue.label, inputValue.magicKey)
            .then((response) => {
                if (response.data && response.data.candidates && response.data.candidates.length > 0) {
                    const latLon = new L.LatLng(response.data.candidates[0].location.y, response.data.candidates[0].location.x);
                    this.$store.dispatch('setMarkerLocation', latLon);
                    this.map.setView(latLon, 16);
                } else {
                    this.$store.dispatch('notify', 'Address not found');
                }
            })
            .catch((error) => {
                console.error(error);
                // this.$store.dispatch('notify', error.stack.split('\n', 1).join(''));
            });
        } else if (inputValue && inputValue.type && inputValue.type === 'listing') {
            SearchService.listingGeometry(inputValue.value)
            .then((response) => {
                if (response.data && response.data.features.length) {
                    if (response.data.features[0].properties.ml === 1 && response.data.features[0].properties.mli !== null) {
                        const listingJson = this.getListingFromMultiListingSearchSelection(inputValue.label, response.data.features[0]);
                        const searchListing = new Listing(listingJson);
                        this.$store.dispatch('setSelectedListing', searchListing);
                    } else {
                        const searchListing = new Listing(response.data.features[0].properties);
                        this.$store.dispatch('setSelectedListing', searchListing);
                    }
                    const latLon = new L.LatLng(response.data.features[0].geometry.coordinates[1], response.data.features[0].geometry.coordinates[0]);
                    this.$store.dispatch('setMarkerLocation', latLon);
                    this.map.setView(latLon, 16);

                }
            })
            .catch((error) => {
                console.error(error);
                // this.$store.dispatch('notify', error.stack.split('\n', 1).join(''));
            });
        } else if (inputValue && inputValue.type && inputValue.type === 'pid') {
            const latLon = new L.LatLng(inputValue.value.geometry.coordinates[0][0][1], inputValue.value.geometry.coordinates[0][0][0]);
            this.$store.dispatch('setMarkerLocation', latLon);
            this.map.setView(latLon, 16);
        } else if (inputValue && inputValue.type && inputValue.type === 'listingAddress') {
            SearchService.listingGeometryBySystemId(inputValue.value)
            .then((response) => {

                if (response.data && response.data.features.length) {
                    console.log('SearchManager: listingGeometryBySystemId ' + JSON.stringify(response.data));
                    if (response.data.features[0].properties.ml === 1 && response.data.features[0].properties.mli !== null) {
                        const listingJson = this.getListingFromMultiListingSearchSelection(inputValue.label, response.data.features[0]);
                        console.log('SearchManager: selectedResult() - setting selected listing ' + JSON.stringify(listingJson));
                        const searchListing = new Listing(listingJson);
                        this.$store.dispatch('setSelectedListing', searchListing);
                    } else {
                        const searchListing = new Listing(response.data.features[0].properties);
                        this.$store.dispatch('setSelectedListing', searchListing);
                    }
                    const latLon = new L.LatLng(response.data.features[0].geometry.coordinates[1], response.data.features[0].geometry.coordinates[0]);
                    this.$store.dispatch('setMarkerLocation', latLon);
                    this.map.setView(latLon, 16);

                }
            })
            .catch((error) => {
                console.error(error);
                // this.$store.dispatch('notify', error.stack.split('\n', 1).join(''));
            });
        }
    }

    public searchInput(inputValue: any, update: any, abort: any) {
        console.log('SearchManager: searchInput()');
        console.log(inputValue);
        if (inputValue && inputValue.length > 1) {
            console.log('SearchManager: fired');
            this.listingAddressResults = [];
            this.addressResults = [];
            this.listingResults = [];
            this.pidResults = [];
            if (inputValue.length >= 4 && !isNaN(inputValue) && !isNaN(parseFloat(inputValue))) {
                // DO MLS searches for nueric values > 4
                SearchService.mlsFuzzyQuery(inputValue)
                .then((response) => {
                    update(() => {
                        if (response.data && response.data.features.length > 0) {
                            response.data.features.forEach((feature: any) => {
                                if (feature.properties.ml === 1 && feature.properties.pid.indexOf(inputValue) === -1 && feature.properties.mli !== null) {
                                    const lSysId = this.getMatchingSystemIdFromMultilisting(feature, inputValue);
                                    this.listingResults.push({
                                        label: `MLS#: ${lSysId} / PID: ${feature.properties.pid}`,
                                        value: feature.properties.OBJECTID,
                                        type: 'listing',
                                    });
                                } else {
                                    this.listingResults.push({
                                        label: `MLS#: ${feature.properties.sid} / PID: ${feature.properties.pid}`,
                                        value: feature.properties.OBJECTID,
                                        type: 'listing',
                                    });
                                }
                            });
                        }
                    });
                })
                .catch((error) => {
                    console.error(error);
                    // this.$store.dispatch('notify', error.stack.split('\n', 1).join(''));
                });

                
            }
            if (inputValue.length === 8 && !isNaN(inputValue) && !isNaN(parseFloat(inputValue))) {
                // DO PID searches for nueric values length == 8
                SearchService.pidExactQuery(inputValue)
                .then((response) => {
                    update(() => {
                        if (response.data && response.data.features.length > 0) {
                            response.data.features.forEach((feature: any) => {
                                this.pidResults.push({
                                    label: `PID: ${feature.properties.PID}`,
                                    value: feature,
                                    type: 'pid',
                                });
                            });
                        }
                    });
                })
                .catch((error) => {
                    console.error(error);
                    // this.$store.dispatch('notify', error.stack.split('\n', 1).join(''));
                });
            }

            SearchService.listingByAddress(inputValue)
                .then((response) => {
                    update(() => {
                        if (response.data && response.data.features.length > 0) {
                            response.data.features.forEach((feature: any) => {
                                this.listingAddressResults.push({
                                    label: `${feature.properties.ad} / MLS#: ${feature.properties.sid}`,
                                    value: feature.properties.sid,
                                    type: 'listingAddress',
                                });
                            });
                        }
                    });
                })
                .catch((error) => {
                    console.error(error);
                    // this.$store.dispatch('notify', error.stack.split('\n', 1).join(''));
                });

            SearchService.esriGeocoderSuggestions(inputValue, this.map.getCenter().lat, this.map.getCenter().lng)
            .then((response) => {
                update(() =>{
                    if (response.data && response.data.suggestions.length > 0) {
                        response.data.suggestions.forEach((suggestion: any) => {
                            if (suggestion && suggestion.text) {
                                const idx = suggestion.text.indexOf(', NS');
                                const idx2 = suggestion.text.indexOf(', Nova Scotia');
                                if (idx === -1 && idx2 === -1) {
                                    return;
                                }
                                const slimAddress = suggestion.text.substring(0, idx);
                                if (!this.addressResults.find((element: any) => element.label === slimAddress)) {
                                    this.addressResults.push({
                                        label: slimAddress,
                                        magicKey: suggestion.magicKey,
                                        type: 'address',
                                    });
                                }
                            }
                        });
                    }
                });
            })
            .catch((error) => {
                console.error(error);
                // this.$store.dispatch('notify', error.stack.split('\n', 1).join(''));
            });
        } else {
            console.log('SearchManager: aborting');
            abort();
        }
    }

    public clearResult() {
        console.log('SearchManager: clearResult()');
    }

    public getMatchingSystemIdFromMultilisting(feature: any, sysIdToMatch: any) {
        const lSysIds = feature.properties.mli.split('|');
        for (const lSysId of lSysIds) {
            if (lSysId.indexOf(sysIdToMatch) !== -1) {
                return lSysId;
            }
        }
        return '';
    }

    public getListingFromMultiListingSearchSelection(selectionText: any, feature: any) {
        let lSysId = null;
        if (selectionText.indexOf('MLS#:') !== -1 && selectionText.indexOf('MLS#:') == 0) {
            console.log('SearchManager: getListingFromMultiListingSearchSelection() - MLS# at start of string');
            const lStart = selectionText.indexOf('MLS#:') + 6;
            const lEnd = selectionText.indexOf(' / ');
            lSysId = parseInt(selectionText.substring(lStart, lEnd), 10);
        }
        else if (selectionText.indexOf('MLS#:') !== -1 ) {
            console.log('SearchManager: getListingFromMultiListingSearchSelection() - MLS# not at start of string');
            const lStart = selectionText.indexOf('MLS#:') + 6;
            const lEnd = selectionText.length;
            lSysId = parseInt(selectionText.substring(lStart, lEnd), 10);
        }
        else {
            console.log('SearchManager: getListingFromMultiListingSearchSelection() - MLS# not found in string, using getMatchingSystemIdFromMultilisting()');
            lSysId = parseInt(this.getMatchingSystemIdFromMultilisting(feature, selectionText), 10);
        }

        console.log('SearchManager: getListingFromMultiListingSearchSelection() - lSysId = ' + lSysId);
        const lListings = JSON.parse(feature.properties.md);
        for (let i = 0; i < lListings.length; i++) {
            if (lListings[i].sid === lSysId) {
                return lListings[i];
            }
        }
        return null;
    }

}

